import { Controller } from "@hotwired/stimulus";

// The linked email thread on a task card. Each message is a native <details>;
// the newest one opens by default and the older ones sit collapsed to one
// line. "Expand all" / "Collapse all" live in the panel header, so the whole
// chain can be opened or folded in one click without leaving the card.
export default class extends Controller {
  static targets = ["message"];

  expandAll(event) {
    event?.preventDefault();
    this.messageTargets.forEach((message) => { message.open = true; });
  }

  collapseAll(event) {
    event?.preventDefault();
    this.messageTargets.forEach((message) => { message.open = false; });
  }
}
